
import { Component, Vue, } from "vue-property-decorator";
import { dispatchGetUserSigmaRings } from "@/store/mlm/actions";
import { readUserSigmaRings } from "@/store/mlm/getters";
import RingsEditOrderModal from "./RingsEditOrderModal.vue";
import EditIcon from "@/components/Icons/EditIcon.vue";
@Component({
  components: {
    RingsEditOrderModal,
    EditIcon,
  }
})
export default class ProductOrders extends Vue {
  public loadingState: boolean = false;
  public isShowEditOrderModal: boolean = false;
  public orderData: any = null;
  public handleShowEditOrderModal(order: any) {
    // console.log('show edit order modal', order);
    this.orderData = order;
    this.isShowEditOrderModal = true;
  }
  public handleCloseEditOrderModal() {
    this.isShowEditOrderModal = false;
  }

  public get userSigmaRings() {
    return readUserSigmaRings(this.$store);
  }

  public async mounted() {
    this.loadingState = true;
    const userSigmaRings = await dispatchGetUserSigmaRings(this.$store);
    //console.log('userSigmaRings', userSigmaRings);
    this.loadingState = false;
  }
}
